import {
  createContext,
  useContext,
  useMemo,
  useState,
  type Dispatch,
  type FC,
  type ReactNode,
  type SetStateAction,
} from 'react';

type LastUpdatedPreviewContextValue = {
  activeReferenceId: string | null;
  setActiveReferenceId: Dispatch<SetStateAction<string | null>>;
};

const LastUpdatedPreviewContext =
  createContext<LastUpdatedPreviewContextValue | null>(null);

export const LastUpdatedPreviewProvider: FC<{ children: ReactNode }> = ({
  children,
}) => {
  const [activeReferenceId, setActiveReferenceId] = useState<string | null>(
    null
  );
  const value = useMemo(
    () => ({ activeReferenceId, setActiveReferenceId }),
    [activeReferenceId]
  );
  return (
    <LastUpdatedPreviewContext.Provider value={value}>
      {children}
    </LastUpdatedPreviewContext.Provider>
  );
};

export function useLastUpdatedPreview(): LastUpdatedPreviewContextValue {
  const ctx = useContext(LastUpdatedPreviewContext);
  if (!ctx) {
    throw new Error(
      'useLastUpdatedPreview must be used within LastUpdatedPreviewProvider'
    );
  }
  return ctx;
}
